// helpers/translation/de.js
export default {
  seo: {
    home: {
      title: 'Artemida Studio — Kreative digitale Lösungen',
      description:
        'Wir erstellen individuelle Websites jeder Komplexität: Landingpages, Unternehmenswebsites und KI-Assistenten.',
      keywords: 'Webentwicklung, Landingpage, Unternehmenswebsite, KI',
    },
    // 🔽 neu: SEO für die Blog-Übersichtsseite
    blog: {
      title: 'Blog — Artemida Studio',
      description:
        'Einblicke in Webentwicklung, Design, KI-Assistenten und den Aufbau moderner Unternehmenswebsites.',
      keywords: 'blog, webentwicklung, design, ki, websites',
    },
  },

  header: {
    homeLink: 'Startseite',
    aboutUsLink: 'Über Uns',
    servicesLink: 'Dienstleistungen',
    ourProjectsLink: 'Unsere Projekte',
    contact: 'Kontakt',
    blogLink: 'Blog',
  },
  heroSection: {
    companyDescription: 'Wir erstellen individuelle Websites jeder Komplexität',
    contactUs: 'Kontaktieren Sie uns',
  },
  aboutUsSection: {
    aboutUsTitle: 'Über Uns',
    aboutUsDescription:
      'Bei Artemida Studio sind wir auf die Erstellung individueller Landingpages und Unternehmenswebsites spezialisiert, die Unternehmen helfen, eine starke Online-Präsenz aufzubauen. Unser Ziel ist es, moderne, funktionale und visuell eindrucksvolle Lösungen zu liefern, die auf die Bedürfnisse Ihrer Marke zugeschnitten sind.\n\n' +
      'Durch die Verbindung von Kreativität, neuesten Technologien und einem persönlichen Ansatz entwickeln wir Websites, die nicht nur ästhetisch ansprechend sind, sondern auch schnell, benutzerfreundlich und vollständig responsiv.\n\n' +
      'Ob Sie eine conversion-starke Landingpage oder eine professionelle Unternehmenswebsite benötigen – Artemida Studio setzt Ihre Vision mit hochwertigen, maßgeschneiderten Lösungen um.\n\n' +
      'Wählen Sie Professionalität und Kreativität – lassen Sie uns gemeinsam Ihre perfekte Website erstellen!',
  },

  // Dienstleistungen (Services)
  services: {
    ourServices: 'Unsere Dienstleistungen',
    servicesDescription:
      'Wir entwickeln hochwertige, maßgeschneiderte digitale Lösungen, die Ihr Geschäft voranbringen',
    contactUs: 'Kontaktieren Sie uns',
    items: [
      {
        key: 'landing',
        title: 'Landing-\nPage',
        descriptionList: [
          'Eine durchdachte Landing-Page ist ein starkes Werkzeug, um Kunden anzuziehen, Conversions zu steigern und die Online-Präsenz Ihrer Marke auszubauen. Bei Artemida Studio erstellen wir hochwertige, maßgeschneiderte Landing-Pages, die auf Ihre Geschäftsziele zugeschnitten sind.',
          '✔️ Modernes & einzigartiges Design – Visuell beeindruckende, markenkonforme Seiten, die Aufmerksamkeit erregen.',
          '✔️ Hohe Conversion-Rate – Optimierte Layouts und überzeugende CTAs für mehr Interaktion.',
          '✔️ Schnell & responsiv – Blitzschnelle Performance und nahtlose Nutzung auf allen Geräten.',
          '✔️ SEO- & Marketing-ready – Nach Best Practices gebaut, um Sichtbarkeit zu erhöhen und organischen Traffic zu gewinnen.',
          '✔️ Vollständig anpassbar – Jedes Detail auf Ihre Anforderungen und Markenidentität zugeschnitten.',
        ],
      },
      {
        key: 'corporate',
        title: 'Unternehmenswebsite',
        descriptionList: [
          'Eine professionelle Unternehmenswebsite ist entscheidend, um Vertrauen aufzubauen, Ihre Marke zu präsentieren und Kunden zu gewinnen. Bei Artemida Studio entwickeln wir individuelle Unternehmenswebsites, die Ihre Werte widerspiegeln und Sie in der digitalen Welt hervorheben.',
          '✔️ Professionelles & einzigartiges Design – Schlanker, moderner Auftritt, perfekt auf Ihre Markenidentität abgestimmt.',
          '✔️ Vollständig anpassbar – Jedes Element wird auf Ihre Geschäftsziele und Anforderungen ausgerichtet.',
          '✔️ Schnell & sicher – Für Geschwindigkeit, Sicherheit und fehlerfreie Performance optimiert.',
          '✔️ SEO- & Marketingfreundlich – Nach Best Practices entwickelt, um die Online-Sichtbarkeit zu erhöhen und neue Kunden zu erreichen.',
          '✔️ Mobil- & benutzerfreundlich – Vollständig responsives Design für ein nahtloses Erlebnis auf allen Geräten.',
          '✔️ Einfache Inhaltsverwaltung – Schnelle Aktualisierungen dank benutzerfreundlichem CMS.',
        ],
      },
      {
        key: 'ai',
        title: 'Integration von KI-Assistenten',
        descriptionList: [
          'Verstärken Sie Ihre Website mit der Kraft von KI! Bei Artemida Studio integrieren wir fortschrittliche KI-Assistenten, die User Experience verbessern, Prozesse automatisieren und das Engagement steigern. Ob intelligenter Chatbot, automatischer Support oder KI-gestützte Empfehlungen – wir liefern nahtlose Lösungen, die zu Ihrem Business passen.',
          '✔️ 24/7-Kundensupport – KI-Chatbots beantworten Anfragen rund um die Uhr und erhöhen die Zufriedenheit.',
          '✔️ Nahtlose Website-Integration – Funktioniert reibungslos innerhalb Ihrer Seite, ohne die Nutzung zu stören.',
          '✔️ Personalisierte User Experience – KI-Interaktionen, die auf Bedürfnisse und Vorlieben der Nutzer eingehen.',
          '✔️ Lead-Generierung & mehr Umsatz – Besucher aktivieren, Leads sammeln und Kund:innen gezielt zum Kauf führen.',
          '✔️ Automatisierung & Effizienz – Prozesse verschlanken, Arbeitsaufwand und Reaktionszeiten reduzieren.',
          '✔️ Individuelle KI-Lösungen – Komplett an Ihr Geschäftsmodell und spezifische Anforderungen anpassbar.',
        ],
      },
    ],
  },
  contactSection: {
    title: 'Lassen Sie uns Ihr Projekt besprechen',
    placeholderName: 'Name',
    placeholderPhone: 'Telefon',
    placeholderEmail: 'E-Mail',
    placeholderMessage: 'Erzählen Sie uns von Ihrem Projekt',
    sendButton: 'Senden',
  },
};
